import React from 'react';
import { Checkbox } from "../../../checkbox/Checkbox.js";
import { InputSearch } from "../../../inputSearch/InputSearch.js";
import { Separator } from "../../../separator/Separator.js";
import { Typography } from "../../../typography/Typography.js";
import styles from "./CheckboxList.module.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function CheckboxList({
  title,
  elements,
  render,
  onChange: handleChange,
  searchTerm,
  onSearchTermChange: setSearchTerm,
  placeholder
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h3",
        margin: false,
        children: title
      }), /*#__PURE__*/_jsx(Separator, {
        marginTop: "1rem",
        marginBottom: "1rem"
      }), /*#__PURE__*/_jsx(InputSearch, {
        value: searchTerm,
        onChange: e => setSearchTerm(e.target.value),
        onClear: () => setSearchTerm(''),
        placeholder: placeholder,
        small: true
      }), /*#__PURE__*/_jsx(Separator, {
        marginTop: "1rem"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.list,
      children: elements.map((element, index) => /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.row,
          children: /*#__PURE__*/_jsx(Checkbox, {
            checked: element.checked,
            classNames: styles.checkbox,
            onChange: e => handleChange?.(element.element, e.target.checked),
            id: element.id,
            childrenErrorContainerClassName: styles.fullWidth,
            children: render(element.element)
          })
        }), /*#__PURE__*/_jsx(Separator, {})]
      }, index))
    })]
  });
}